export default __webpack_public_path__ + "static/media/DouglasHaynes.8f7ecce7.jpg";